export const descriptionFunction=(arr)=>{
    const arrJoin = arr.join(" ");
    const result = arrJoin.split("\n");
    // console.log(result.filter((e)=> e));
    return result.filter((e)=>e)
}
export const userRoles = {
    creator:'creator',
    visitor:'visitor'
}